module.exports = __webpack_public_path__ + "img/growcify-dashboard-banner-9.aeee1012.png";